import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 7H3v10h18V7zm-2 8H5V9h14v6z"
}), 'Crop75Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Crop75Sharp.js
// module id = 3002
// module chunks = 2